if (typeof ARCHIPEL === "undefined") {
  var ARCHIPEL = {};
}

import { menu } from "./actions/menu";
import { scroll } from "./actions/scroll";

import "../scss/styles.scss";
!function ($) {
  "use strict";

  jQuery(document).ready(function ($) {
    menu.init();
    scroll.init();

    setTimeout(function(){
      $(".ced-first-cols").each(function(){
        var colCover = $(this).find(".wp-block-column").find(".wp-block-cover");
        var colTitle = $(this).find(".wp-block-column").find(".wp-block-heading");
        colCover.parent().addClass("ced-col-cover");
        colTitle.parent().addClass("ced-col-main");
      });
  
      $(".ced-col-main").each(function(){
        var target = $(this).parents(".wp-block-columns").attr("data-target");
        var learnMore = $("body").attr("data-lang") == "en_US" ? 'Learn more' : 'En savoir plus';
        console.log(target);
        $(this).append(
          '<div class="wp-block-group is-nowrap is-layout-flex wp-container-core-group-layout-1 wp-block-group-is-layout-flex reveal active" style="padding-right:var(--wp--preset--spacing--40);padding-left:var(--wp--preset--spacing--40)"><div class="wp-block-buttons is-layout-flex wp-block-buttons-is-layout-flex reveal active"><div class="wp-block-button"><a href="' + target + '" class="wp-block-button__link wp-element-button">' + learnMore + '</a></div></div></div><div style="height:var(--wp--preset--spacing--30)" aria-hidden="true" class="wp-block-spacer"></div>'
        );
      });
    }, 500)
  });
}.call(ARCHIPEL, jQuery);
